/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TFilterVacanciesModel,
  IFilterVacanciesRequest,
  IMappers,
  IFilterVacanciesResponse,
  IFilterVacanciesResponseError,
  TFilterVacanciesResponse,
} from './types';

const defaultConfig: TFilterVacanciesModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'vacancies',
  pathApi: '/v1/filter-vacancies/',
  hostType: 'api',
} as TFilterVacanciesModel;

function createFilterVacanciesModel(parameters: IFilterVacanciesRequest): TFilterVacanciesModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IFilterVacanciesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IFilterVacanciesRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchFilterVacancies<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IFilterVacanciesOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TFilterVacanciesResponse
> {
  const { response, statusCode } = await httpApi.fetch(createFilterVacanciesModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IFilterVacanciesResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IFilterVacanciesResponseError);
    }
  }

  return { response, statusCode } as TFilterVacanciesResponse;
}

export { defaultConfig, createFilterVacanciesModel, fetchFilterVacancies };
